import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Center } from "@mantine/core";
import { Image as ImageIcon } from "./assets/icons.generated";
const MediaPlaceholder = ({ size, iconSize }) => {
    return (_jsx(Center, { sx: (theme) => ({
            height: size,
            width: size,
            maxHeight: size,
            maxWidth: size,
            border: `1px dashed ${theme.colors.divider[0]}`,
        }), children: _jsx(ImageIcon, { width: iconSize, height: iconSize }) }));
};
export default MediaPlaceholder;
